module.exports = __webpack_public_path__ + "img/04.a7bc76b0.jpg";